import { render, staticRenderFns } from "./signout-callback-oidc.vue?vue&type=template&id=b9f62824&scoped=true"
import script from "./signout-callback-oidc.vue?vue&type=script&lang=js"
export * from "./signout-callback-oidc.vue?vue&type=script&lang=js"
import style0 from "./signout-callback-oidc.vue?vue&type=style&index=0&id=b9f62824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f62824",
  null
  
)

export default component.exports